import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const chatService = {
  /**
   * Chatbot'u baslatir, karsilama mesaji ve secenekleri getirir
   */
  startChat: async (customerName, customerSurname, customerPhone, kvkkAccepted = true, acikRizaAccepted = true) => {
    const payload = { customerName, customerSurname, customerPhone, kvkkAccepted, acikRizaAccepted };
    const response = await apiClient.post('/chat/start', payload);
    return response.data;
  },

  /**
   * Kullanicinin sectigi opsiyonu backend'e gonderir.
   * sessionId: Konusma oturumu (LLM gecmisi icin)
   */
  selectOption: async (selectedOption, sessionId) => {
    const response = await apiClient.post('/chat/select', {
      selectedOption,
      sessionId,
    });
    return response.data;
  },

  /**
   * Kullanicinin serbest metin mesajini LLM'e gonderir.
   * Backend intent siniflandirir, parametre toplar, cevap uretir.
   */
  sendMessage: async (message, sessionId) => {
    const response = await apiClient.post('/chat/message', {
      message,
      sessionId,
    });
    return response.data;
  },

  /**
   * Mevcut secenekleri getirir
   */
  getOptions: async () => {
    const response = await apiClient.get('/chat/options');
    return response.data;
  },

  /**
   * Geri bildirim (puan + yorum) gonderir
   */
  submitFeedback: async (rating, comment, sessionId, customerName) => {
    const response = await apiClient.post('/chat/feedback', {
      rating,
      comment: comment || null,
      sessionId,
      customerName,
    });
    return response.data;
  },
};

export default chatService;
